<template>
    <div class="flats-crm-topbar">
        <div class="col col-left">
            <div class="btns-cards-view-mobile">
                <div class="btns">
                    <div class="item" :class="{active: gridView}">
                        <a href="#" class="btn-view-grid btn-change-cards-view" @click.prevent="setGridView(true)">
                            <svg-icon icon-class="grid" className="icon-grid"/>
                        </a>
                    </div>
                    <div class="item" :class="{active: !gridView}">
                        <a href="#" class="btn-view-list btn-change-cards-view"@click.prevent="setGridView(false)">
                            <svg-icon icon-class="list" className="icon-list"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-center">
            <!-- тут должны быть параметры сортировки -->
        </div>
        <div class="col col-right">
            <div class="filter-link">
                <a href="#" @click.prevent="openFilterWindow">
                    <svg-icon icon-class="filter" className="icon-filter"/>
                    <span>Фильтр</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-flats-topbar',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            filterVisible: 'loadVisibleFilterMobile',
			gridView: 'loadLandFlatsGridView',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
        }),
        methods: {
            setGridView(param) { 
				this.$store.commit('gridView', param);
            },
            openFilterWindow() {
                window.body.addClass('overflowTrue');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                }
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
				this.$store.commit('SetVisibleFilterMobile', true);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/respond/flats-crm-topbar.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>